import { COMMON_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const SUPPORTED_CHROME_VERSION = '115'
export const SUPPORTED_SAFARI_VERSION = '18.2'
export const SUPPORTED_FIREFOX_VERSION = '137.0.2'
export const SUPPORTED_EDGE_VERSION = '135.0.3179.85'

export const USER_AGENT_CHROME_REGEX = /Chrome\/(\d+\.\d+\.\d+\.\d+)/

export const USER_AGENT_CHROME_KEY = 'Chrome'
export const USER_AGENT_SAFARI_KEY = 'Safari'
export const USER_AGENT_FIREFOX_KEY = 'Firefox'
export const USER_AGENT_EDGE_KEY = 'Microsoft Edge'
export const USER_AGENT_GOOGLE_SEARCH_KEY = 'Google Search'

export const BROWSER_COMPATIBILITY_VIEW_IMAGE = `${COMMON_BASE_URL_PREFIX}/images/browser-compatability.png`

export const BROWSER_COMPATIBILITY_VIEW_BG_IMAGE = `${COMMON_BASE_URL_PREFIX}/images/browser-compatability-bg.png`

export const BROWSER_NOT_COMPATIBLE_IMAGE = `${COMMON_BASE_URL_PREFIX}/images/browser-not-compatible.png`
